// Romania hotels grouped by region. Regions become the tabs on the
// Romania destinations page; each hotel is a clickable card that links
// to the Romania booking page.

export interface RomaniaHotel {
  id: number;
  name: string;
  region: string;
  location: string;
  description: string;
  image: string;
  alt: string;
}

// Region tabs, in the order they should appear.
export const romaniaRegions = [
  'Bucharest',
  'Danube Delta',
  'Brașov',
  'Carpathians & Transylvania',
  'Sighișoara & Viscri',
  'Maramureș',
  'Bucovina',
] as const;

const IMG = {
  buch1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782931463453_15ccfc63.jpeg',
  buch2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757621284_0609c0bc.jpeg',
  buch3: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757620073_8392229c.jpeg',
  delta1: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757844863_053f042a.jpeg',
  delta2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757845153_2cab6ba2.jpeg',
  chalet1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750093311_f75b0da5.png',
  chalet2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750098883_210354fd.png',
  chalet3: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750095836_85494712.jpg',
  estate1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750119475_9d0ce4a4.png',
  estate2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750117498_aae8d147.jpg',
  estate3: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750122576_0ba76510.png',
  saxon1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750147082_9f17f4e9.png',
  saxon2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750150552_61940410.jpg',
  saxon3: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750151374_1105e96b.jpg',
  farm1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750170558_d59ed0fc.jpg',
  farm2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750173059_8208d0cf.png',
  bucov1: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931006294_3c3c797e.jpeg',
  bucov2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931008489_ad12bbec.jpeg',
  bucov3: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931008275_5377ea3c.jpeg',
  bioFarm1: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932349922_48764b2f.jpeg',
  bioFarm2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750225354_0aa61140.png',
  castle1: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750248825_cbeefd4a.png',
  castle2: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750248001_d540bf24.jpg',
  castle3: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782750251601_827f2870.png',
  carp1: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931047437_eb42ee45.jpeg',
  carp2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931047707_dbd7e09e.jpeg',
  carp3: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931047978_7689596c.jpeg',
  carp4: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931048186_ab4f92e0.jpeg',
  carp5: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931048399_2fb8f983.jpeg',
  carp6: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931048703_b70c4fbb.jpeg',
  carp7: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931048893_65b8bed5.jpeg',
  casaTimis1: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931207494_5b7c0036.jpeg',
  casaTimis2: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931207840_70b9d531.jpeg',
  casaTimis3: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931207997_44134be1.jpeg',
  casaTimis4: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931208210_31b56785.jpeg',
  casaTimis5: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931208381_b3326a65.jpeg',
  casaTimis6: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931208630_2f00bb44.jpeg',
  casaTimis7: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931208794_6bfb25b0.jpeg',
  // ── Raven's Nest (uploaded photos) ──
  ravensAerial: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522451595_039232d8.jpeg',
  ravensCottage: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522452789_77564be0.jpeg',
  ravensVillage: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522452987_0db9f8a5.jpeg',
  ravensDeckGuests: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522453623_4da3bd1e.jpeg',
  ravensDeckSunset: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522453969_ac710b2a.jpeg',
  ravensBedroom: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522454257_9332fc42.jpeg',
  ravensDining: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522454510_b48d6a6d.jpeg',
  ravensDiningTray: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522454830_3cd0809c.jpeg',
  // ── Sadova Village (uploaded photos) ──
  sadovaHouse: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783533179277_af80c71b.webp',
  sadovaBedroom: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783522482304_907d99c6.jpeg',
  // ── Teleferic Grand Hotel (uploaded photos) ──
  telefericExterior: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1783533708719_ff2a781c.webp',
  telefericSuite: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783533367636_5be46b04.jpeg',
  // ── The Marmorosch, Autograph Collection (uploaded photos) ──
  marmoroschFacade: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783619871454_128b6efe.jpeg',
  marmoroschSuite: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783619872771_f80e5e9b.jpeg',
  // ── The Pine Lodge Bucegi (uploaded photos) ──
  pineLodgeExterior: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783619899895_b5559d63.jpeg',
  pineLodgeSuite: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783619900244_4e952f6c.jpeg',
  // ── The Szekler — Transylvania Countryside Estate (uploaded photos) ──
  szeklerEstateSunset: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783620119217_1404d45e.jpeg',
  szeklerAtticBedroom: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783620119524_64a9b48f.jpeg',
  szeklerSuite: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783620119747_6a457eba.jpeg',
  szeklerVillageGate: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783620119967_52222438.jpeg',
};



// Raven's Nest uploaded photo-set (used for the hotel card and the
// Destination Gallery's "Raven's Nest / Apuseni" location category).
export const ravensNestPhotos: { src: string; alt: string }[] = [
  { src: IMG.ravensAerial, alt: 'Aerial dusk view of Raven\'s Nest cottages glowing above an Apuseni Mountains valley, Romania.' },
  { src: IMG.ravensVillage, alt: 'Restored traditional cottages of Raven\'s Nest against the Apuseni Mountains panorama, Romania.' },
  { src: IMG.ravensCottage, alt: 'Thatched-roof traditional cottage at Raven\'s Nest in the Apuseni Mountains, Romania.' },
  { src: IMG.ravensDeckGuests, alt: 'Guests relaxing on the panoramic viewing deck above the valley at Raven\'s Nest, Romania.' },
  { src: IMG.ravensDeckSunset, alt: 'Sunset over the wooden lounge deck at Raven\'s Nest in the Apuseni Mountains, Romania.' },
  { src: IMG.ravensBedroom, alt: 'Rustic attic bedroom with wool blankets and kilim rug at Raven\'s Nest, Romania.' },
  { src: IMG.ravensDining, alt: 'Farm-to-table dishes and local wine served at Raven\'s Nest, Apuseni Mountains, Romania.' },
  { src: IMG.ravensDiningTray, alt: 'A tray of local dishes served on the wooden deck at Raven\'s Nest, Romania.' },
];

// Sadova Village uploaded photo-set (used for the hotel card and the
// Destination Gallery's "Sadova / Bucovina" location category).
export const sadovaVillagePhotos: { src: string; alt: string }[] = [
  { src: IMG.sadovaHouse, alt: 'Traditional whitewashed house with carved wooden porch at Sadova Village, framed by apple trees, Bucovina, Romania.' },
  { src: IMG.sadovaBedroom, alt: 'Warm four-poster timber bed in a rustic-chic guest room at Sadova Village, Bucovina, Romania.' },
];

// Teleferic Grand Hotel uploaded photo-set (used for the hotel card and the
// Destination Gallery's "Teleferic / Poiana Brașov" location category).
export const telefericGrandHotelPhotos: { src: string; alt: string }[] = [
  { src: IMG.telefericExterior, alt: 'Illuminated timber-and-stone façade of Teleferic Grand Hotel at dusk, its flower-lined balconies glowing in Poiana Brașov, Romania.' },
  { src: IMG.telefericSuite, alt: 'Spacious chalet-style suite with vaulted timber ceilings and a forest-view balcony at Teleferic Grand Hotel, Poiana Brașov, Romania.' },
];

// The Marmorosch, Autograph Collection uploaded photo-set (used for the hotel
// card and the Destination Gallery's "The Marmorosch / Bucharest" category).
export const marmoroschPhotos: { src: string; alt: string }[] = [
  { src: IMG.marmoroschFacade, alt: 'Ornate carved-stone façade of The Marmorosch, Autograph Collection — the restored former Marmorosch Blank Bank with vintage cars at its entrance, Bucharest Old Town, Romania.' },
  { src: IMG.marmoroschSuite, alt: 'Wood-panelled suite with a plush headboard, herringbone parquet and tall curtained windows at The Marmorosch, Autograph Collection, Bucharest, Romania.' },
];

// The Pine Lodge Bucegi uploaded photo-set (used for the hotel card and the
// Destination Gallery's "The Pine Lodge / Bucegi" location category).
export const pineLodgeBucegiPhotos: { src: string; alt: string }[] = [
  { src: IMG.pineLodgeExterior, alt: 'Timber-and-glass façade of The Pine Lodge glowing at dusk against snow-dusted Bucegi Mountain ridgelines, near Brașov, Romania.' },
  { src: IMG.pineLodgeSuite, alt: 'Sunlit suite with exposed timber-beam ceilings, sheer curtains and a leather lounge chair at The Pine Lodge Bucegi, Romania.' },
];

// The Szekler — Transylvania Countryside Estate uploaded photo-set (used for
// the hotel card and the Destination Gallery's "The Szekler / Szeklerland" category).
export const szeklerEstatePhotos: { src: string; alt: string }[] = [
  { src: IMG.szeklerEstateSunset, alt: 'Thatched-roof main house of The Szekler, Transylvanian countryside estate, glowing beneath a fiery sunset in Szeklerland, Romania.' },
  { src: IMG.szeklerSuite, alt: 'Elegant guest suite with arched windows, flowing drapes and a kilim rug at The Szekler estate, Transylvania, Romania.' },
  { src: IMG.szeklerAtticBedroom, alt: 'Cosy canopied attic bedroom with warm lamplight and oak floors at The Szekler estate, Transylvania, Romania.' },
  { src: IMG.szeklerVillageGate, alt: 'Carved wooden Szekler gate and traditional village houses with grazing sheep in Szeklerland, Transylvania, Romania.' },
];





export const romaniaHotels: RomaniaHotel[] = [
  // ── Bucharest ──────────────────────────────────────────────
  {
    id: 101,
    name: 'Corinthia Grand Hotel du Boulevard',
    region: 'Bucharest',
    location: 'Historic Centre, Bucharest',
    description:
      'A meticulously restored 19th-century landmark on the edge of Bucharest\'s old town, blending Belle Époque grandeur with five-star service. Steps from the Palace of the Parliament and the bustling Historic Centre cafés.',
    image: IMG.buch1,
    alt: 'Grand Belle Époque facade of the Corinthia Grand Hotel du Boulevard in central Bucharest, Romania.',
  },
  {
    id: 102,
    name: 'InterContinental Athénée Palace',
    region: 'Bucharest',
    location: 'Revolution Square, Bucharest',
    description:
      'A storied palace hotel facing the Romanian Athenaeum and Revolution Square, long the meeting point of diplomats and writers. Elegant rooms put the capital\'s grandest boulevards and Belle Époque architecture at your doorstep.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932043242_992cc988.jpeg',
    alt: 'Elegant historic Athénée Palace hotel facade overlooking Revolution Square in Bucharest, Romania.',
  },
  {
    id: 103,
    name: 'The Marmorosch Bucharest',
    region: 'Bucharest',
    location: 'Old Town, Bucharest',
    description:
      'Set inside a magnificent former bank in the heart of the Old Town, The Marmorosch pairs Art Deco heritage with a rooftop bar and refined dining. Ideally placed for the Arch of Triumph and the city\'s historic core.',
    image: IMG.marmoroschFacade,
    alt: 'Ornate carved-stone façade of The Marmorosch, Autograph Collection — the restored former Marmorosch Blank Bank with vintage cars at its entrance, Bucharest Old Town, Romania.',

  },

  // ── Danube Delta ───────────────────────────────────────────
  {
    id: 201,
    name: 'Lebăda Luxury Resort & Spa',
    region: 'Danube Delta',
    location: 'Crișan, Danube Delta',
    description:
      'A serene waterfront retreat deep within the UNESCO Danube Delta Biosphere Reserve, surrounded by reed beds and birdlife. Spa, fine dining and private boat safaris through Europe\'s largest wetland are all on the doorstep.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932602245_fb939202.jpeg',
    alt: 'Waterfront Lebăda Luxury Resort & Spa among the reed channels of the Danube Delta, Romania.',
  },
  {
    id: 202,
    name: 'Green Village Resort',
    region: 'Danube Delta',
    location: 'Sfântu Gheorghe, Danube Delta',
    description:
      'Charming reed-thatched villas beside the channels of the Danube Delta near the wild Black Sea beaches of Sfântu Gheorghe. A tranquil eco-base for wildlife, boating and birdwatching among 300+ species.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931953303_db75c491.png',
    alt: 'Reed-roofed eco villas of Green Village Resort beside the Danube Delta channels in Romania.',
  },

  // ── Brașov ─────────────────────────────────────────────────
  {
    id: 301,
    name: 'Matca Hotel — Relais & Châteaux',
    region: 'Brașov',
    location: 'Brașov, Transylvania',
    description:
      'An intimate Relais & Châteaux address framed by the Carpathians, celebrated for its locavore cuisine and design-led rooms. A polished base for Brașov\'s medieval Council Square and the Black Church.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932856065_6db815dd.jpeg',
    alt: 'Luxury mountain hotel Matca near Brașov in the Carpathians, Transylvania, Romania.',
  },
  {
    id: 302,
    name: 'Casa Timiș Spa Resort',
    region: 'Brașov',
    location: 'Prahova Valley, near Brașov',
    description:
      'A vineyard-and-spa retreat in the Prahova Valley combining a working winery, wellness suites and Carpathian views. Perfectly placed between Sinaia\'s Peleș Castle and historic Brașov.',
    image: IMG.casaTimis1,
    alt: 'Casa Timiș Spa Resort with vineyards and Carpathian mountain views near Brașov, Romania.',
  },
  {
    id: 303,
    name: 'Daniel Castle',
    region: 'Brașov',
    location: 'Tălișoara, near Brașov',
    description:
      'A restored Renaissance noble castle turned boutique hotel, all vaulted halls, antiques and quiet courtyards. An atmospheric Transylvanian stay within reach of Brașov and Bran Castle.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931684848_6b8f938c.jpeg',
    alt: 'Restored Renaissance Daniel Castle boutique hotel in Transylvania near Brașov, Romania.',
  },
  {
    id: 304,
    name: 'The Pine Lodge Bucegi',
    region: 'Brașov',
    location: 'Bucegi Mountains, near Brașov',
    description:
      'A timber-and-stone alpine lodge tucked into the Bucegi Mountains, with crackling fires and panoramic ridgelines. Ideal for hiking, skiing and exploring the Prahova Valley resorts.',
    image: IMG.pineLodgeExterior,
    alt: 'Timber-and-glass façade of The Pine Lodge glowing at dusk against snow-dusted Bucegi Mountain ridgelines, near Brașov, Romania.',
  },
  {
    id: 305,
    name: 'Nuba Chalet',
    region: 'Brașov',
    location: 'Poiana Brașov',
    description:
      'A stylish ski-in chalet in the resort of Poiana Brașov, blending contemporary comfort with mountain warmth. Slopes, cable cars and the old town of Brașov are all minutes away.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783007082040_1418d3d2.jpeg',
    alt: 'Modern Nuba ski chalet in Poiana Brașov, Romania.',
  },
  {
    id: 306,
    name: 'Teleferic Grand Hotel',
    region: 'Brașov',
    location: 'Poiana Brașov',
    description:
      'A grand mountain hotel at the foot of the Poiana Brașov slopes, with a spa, fine dining and sweeping forest views. A refined gateway to the Carpathians and medieval Brașov.',
    image: IMG.telefericExterior,
    alt: 'Illuminated timber-and-stone façade of Teleferic Grand Hotel at dusk, its flower-lined balconies glowing in Poiana Brașov, Romania.',
  },
  {
    id: 307,
    name: 'Das Fort Boutique — Râșnov',
    region: 'Brașov',
    location: 'Râșnov, near Brașov',
    description:
      'A characterful boutique stay beneath the medieval Râșnov Citadel, mixing fortress history with cosy modern rooms. Centrally placed for Bran Castle, Brașov and the Bucegi trails.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931859311_be0fc337.jpeg',
    alt: 'Das Fort boutique hotel beneath the medieval citadel of Râșnov, Romania.',
  },
  {
    id: 308,
    name: 'Yager Chalet',
    region: 'Brașov',
    location: 'Bran, near Brașov',
    description:
      'A secluded designer chalet in the meadows around Bran, with floor-to-ceiling views of the Piatra Craiului ridge. A peaceful retreat moments from Dracula\'s legendary castle.',
    image: IMG.chalet3,
    alt: 'Secluded Yager designer chalet in the meadows near Bran, Romania.',
  },
  {
    id: 309,
    name: 'Zara Chalet Bran',
    region: 'Brașov',
    location: 'Bran, near Brașov',
    description:
      'A welcoming alpine-style chalet hotel in Bran, with a spa, pool and panoramic terraces facing the Carpathians. The perfect base to combine Bran Castle, Râșnov and Brașov.',
    image: IMG.castle3,
    alt: 'Zara alpine chalet hotel with Carpathian views in Bran, Romania.',
  },

  // ── Carpathians & Transylvania ─────────────────────────────
  {
    id: 401,
    name: 'Zabola Estate',
    region: 'Carpathians & Transylvania',
    location: 'Zăbala, Covasna',
    description:
      'A private aristocratic estate on the edge of a vast forest reserve, home to brown bears and centuries of Mikes family history. Elegant guesthouses, wild gardens and Carpathian wilderness right outside.',
    image: IMG.carp1,
    alt: 'Aristocratic Zabola Estate manor surrounded by Carpathian forest in Transylvania, Romania.',
  },
  {
    id: 402,
    name: 'Bálványos Resort',
    region: 'Carpathians & Transylvania',
    location: 'Bálványos, Covasna',
    description:
      'A mountain wellness resort set among volcanic peaks and mineral springs in the eastern Carpathians. Thermal spa, panoramic pools and trails through the Szekler highlands define the stay.',
    image: IMG.carp2,
    alt: 'Bálványos mountain wellness resort among the volcanic Carpathian peaks of Transylvania, Romania.',
  },
  {
    id: 403,
    name: 'The Szekler — Transylvania Countryside Estate',
    region: 'Carpathians & Transylvania',
    location: 'Szeklerland, Transylvania',
    description:
      'A refined countryside estate immersed in Szekler village life, with farm-to-table dining and rolling meadow views. A tranquil escape into rural Transylvania\'s timeless landscapes.',
    image: IMG.szeklerEstateSunset,
    alt: 'Thatched-roof main house of The Szekler, Transylvanian countryside estate, glowing beneath a fiery sunset in Szeklerland, Romania.',

  },
  {
    id: 404,
    name: 'Bethlen Estates',
    region: 'Carpathians & Transylvania',
    location: 'Criș, Mureș',
    description:
      'Beautifully restored noble houses in the Saxon village of Criș, beside the imposing Bethlen Castle. Slow living, heritage interiors and the gentle hills of central Transylvania.',
    image: IMG.carp4,
    alt: 'Restored Bethlen Estates noble houses in the Saxon village of Criș, Transylvania, Romania.',
  },
  {
    id: 405,
    name: 'Bethlen Haller Castle',
    region: 'Carpathians & Transylvania',
    location: 'Cetatea de Baltă, Alba',
    description:
      'A fairytale Renaissance-Baroque castle set among the Jidvei vineyards, blending aristocratic grandeur with Transylvanian wine country. Grand halls, manicured gardens and cellar tastings await.',
    image: IMG.carp5,
    alt: 'Bethlen Haller Castle among the Jidvei vineyards of Transylvania, Romania.',
  },
  {
    id: 406,
    name: 'ISSA Resort',
    region: 'Carpathians & Transylvania',
    location: 'Săliște, Sibiu',
    description:
      'A polished resort and spa in the Mărginimea Sibiului hills, pairing contemporary comfort with shepherding traditions. A scenic base for Sibiu, the Cindrel Mountains and Saxon villages.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932171900_10bd5414.jpeg',
    alt: 'ISSA Resort set in the hills of Mărginimea Sibiului near Sibiu, Romania.',
  },
  {
    id: 407,
    name: 'Raven\'s Nest',
    region: 'Carpathians & Transylvania',
    location: 'Apuseni Mountains, Alba',
    description:
      'A collection of restored traditional cottages perched above a hidden valley in the Apuseni Mountains. Off-grid serenity, hammocks over the gorge and some of Transylvania\'s most romantic views.',
    image: IMG.ravensAerial,
    alt: 'Aerial dusk view of Raven\'s Nest, restored cottages glowing above an Apuseni Mountains valley, Transylvania, Romania.',
  },


  // ── Sighișoara & Viscri ────────────────────────────────────
  {
    id: 501,
    name: 'Viscri 125',
    region: 'Sighișoara & Viscri',
    location: 'Viscri, Transylvania',
    description:
      'A lovingly restored Saxon farmstead guesthouse in the UNESCO village of Viscri, with whitewashed courtyards and a slow-food kitchen. Steps from the famous fortified church and rolling pastures.',
    image: IMG.saxon1,
    alt: 'Restored Saxon guesthouse Viscri 125 in the UNESCO village of Viscri, Transylvania, Romania.',
  },
  {
    id: 502,
    name: 'Viscri 32',
    region: 'Sighișoara & Viscri',
    location: 'Viscri, Transylvania',
    description:
      'An intimate heritage guesthouse blending traditional Saxon architecture with elegant comfort. A peaceful base to explore Viscri\'s fortified church, craft workshops and meadow walks.',
    image: IMG.saxon2,
    alt: 'Heritage Saxon guesthouse Viscri 32 in Viscri village, Transylvania, Romania.',
  },
  {
    id: 503,
    name: 'Azuria Viscri',
    region: 'Sighișoara & Viscri',
    location: 'Viscri, Transylvania',
    description:
      'A serene boutique retreat in Viscri, mixing restored village charm with a quiet garden and locally sourced dining. Ideal for unwinding in one of Transylvania\'s most authentic hamlets.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782752830130_7379f3e7.jpeg',
    alt: 'Azuria boutique guesthouse in the Saxon village of Viscri, Transylvania, Romania.',
  },
  {
    id: 504,
    name: 'Viscri 161',
    region: 'Sighișoara & Viscri',
    location: 'Viscri, Transylvania',
    description:
      'A characterful Saxon house guesthouse with rustic-chic rooms, a leafy courtyard and home-cooked Transylvanian fare. A short stroll from Viscri\'s celebrated fortified church.',
    image: IMG.saxon1,
    alt: 'Viscri 161 Saxon guesthouse courtyard in Viscri village, Transylvania, Romania.',
  },
  {
    id: 505,
    name: 'Alma Via Guesthouse',
    region: 'Sighișoara & Viscri',
    location: 'Alma Vii, near Sighișoara',
    description:
      'A restored Saxon guesthouse in the quiet village of Alma Vii, near the medieval citadel of Sighișoara. Authentic countryside hospitality among fortified churches and gentle hills.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782752629075_2a60e21a.jpeg',
    alt: 'Alma Via guesthouse in Alma Vii village near Sighișoara, Transylvania, Romania.',
  },

  // ── Maramureș ──────────────────────────────────────────────
  {
    id: 601,
    name: 'Prispa Resort',
    region: 'Maramureș',
    location: 'Breb, Maramureș',
    description:
      'A boutique countryside resort in the storybook village of Breb, with carved-wood architecture and panoramic Gutâi mountain views. A serene gateway to Maramureș\'s living rural traditions.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1783007470989_9b532fe7.jpeg',
    alt: 'Prispa Resort wooden cottage in the village of Breb, Maramureș, Romania.',
  },
  {
    id: 602,
    name: 'The Village Pension Breb',
    region: 'Maramureș',
    location: 'Breb, Maramureș',
    description:
      'A cosy family-run pension in Breb, surrounded by hay meadows, orchards and ancient wooden churches. Authentic Maramureș hospitality, home cooking and timeless village life.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782758387355_d299c21a.jpeg',
    alt: 'The Village Pension, a whitewashed traditional cottage in Breb, Maramureș, Romania.',
  },
  {
    id: 603,
    name: 'Alex și Mara',
    region: 'Maramureș',
    location: 'Maramureș Countryside',
    description:
      'A warm guesthouse deep in the Maramureș countryside, where carved gates and folk traditions meet comfortable rooms. Ideal for exploring wooden churches and the Merry Cemetery.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782752573079_8e875bb9.jpeg',
    alt: 'Alex și Mara guesthouse in the Maramureș countryside, Romania.',
  },

  // ── Bucovina ───────────────────────────────────────────────
  {
    id: 701,
    name: 'Bio Valeputna',
    region: 'Bucovina',
    location: 'Putna, Bucovina',
    description:
      'An organic mountain retreat near the historic Putna Monastery, set among forested Carpathian hills. Farm-to-table dining and tranquil nature trails define this Bucovina escape.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782931008776_2df08e2d.jpeg',
    alt: 'Bio Valeputna organic mountain retreat near Putna, Bucovina, Romania.',
  },
  {
    id: 702,
    name: 'Vatra Boierească',
    region: 'Bucovina',
    location: 'Bucovina Countryside',
    description:
      'A refined country estate evoking old Bucovina nobility, with elegant rooms and a heritage restaurant. A graceful base for the UNESCO painted monasteries and rolling hills.',
    image: IMG.bucov2,
    alt: 'Vatra Boierească country estate in the Bucovina countryside, Romania.',
  },
  {
    id: 703,
    name: 'Loft Chalet Bucovina',
    region: 'Bucovina',
    location: 'Bucovina Mountains',
    description:
      'A contemporary design chalet nestled among Bucovina\'s wooded slopes, with floor-to-ceiling forest views. Modern comfort within easy reach of Voroneț and the painted monasteries.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932829208_b6c44c6f.jpeg',
    alt: 'Modern Loft Chalet among the wooded slopes of Bucovina, Romania.',
  },
  {
    id: 704,
    name: 'Montchalet Călimani',
    region: 'Bucovina',
    location: 'Călimani Mountains, Bucovina',
    description:
      'A secluded alpine chalet on the edge of the Călimani Mountains, perfect for hiking, stargazing and mountain quiet. A nature-immersed base for exploring southern Bucovina.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932981405_f5ef6a1d.jpeg',
    alt: 'Montchalet alpine retreat in the Călimani Mountains of Bucovina, Romania.',
  },
  {
    id: 705,
    name: 'La Roata',
    region: 'Bucovina',
    location: 'Gura Humorului, Bucovina',
    description:
      'A charming traditional guesthouse near Gura Humorului, celebrated for hearty Bucovina cuisine and warm hospitality. Ideally placed for Voroneț, Humor and the region\'s frescoed monasteries.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782932247392_2886a1ce.jpeg',
    alt: 'La Roata traditional guesthouse near Gura Humorului, Bucovina, Romania.',
  },
  {
    id: 706,
    name: 'Sadova Village',
    region: 'Bucovina',
    location: 'Sadova, Bucovina',
    description:
      'A peaceful village resort in Sadova, surrounded by spruce forests and the Bistrița valley. A restful retreat for slow days, mountain air and monastery excursions.',
    image: IMG.sadovaHouse,
    alt: 'Traditional whitewashed house with carved wooden porch at Sadova Village, framed by apple trees, Bucovina, Romania.',
  },

  {
    id: 707,
    name: 'La Saivan Bio Retreat & Farm',
    region: 'Bucovina',
    location: 'Bucovina Highlands',
    description:
      'An organic farm-stay in the Bucovina highlands, with grazing flocks, pastures and a true taste of pastoral life. Rustic-luxe lodges and homegrown food make for a deeply restorative escape.',
    image: IMG.bioFarm1,
    alt: 'La Saivan organic bio retreat and farm in the Bucovina highlands, Romania.',
  },
];
